import { emailSchema, passwordSchema } from "@/utils/validation";

export interface AccountCredentialErrors {
  email?: string;
  password?: string;
}

export interface AccountCredentialValidation {
  normalizedEmail: string;
  errors: AccountCredentialErrors;
  isValid: boolean;
}

/**
 * Keeps the inline anonymous-account gates aligned with /api/auth/upgrade.
 * The server still validates authoritatively; this shared client pass prevents
 * forms from promising that a password is valid when the API will reject it.
 */
export function validateAccountCredentials(
  email: string,
  password: string
): AccountCredentialValidation {
  const normalizedEmail = email.trim();
  const emailResult = emailSchema.safeParse(normalizedEmail);
  const passwordResult = passwordSchema.safeParse(password);
  const errors: AccountCredentialErrors = {};

  if (!emailResult.success) {
    errors.email = emailResult.error.issues[0]?.message;
  }
  if (!passwordResult.success) {
    errors.password = passwordResult.error.issues[0]?.message;
  }

  return {
    normalizedEmail,
    errors,
    isValid: emailResult.success && passwordResult.success,
  };
}
